<div *ngIf="!cookieConsentValues" class="user-cookies-consent mat-elevation-z6">
    <div class="user-cookies-consent__wrapper">
        <div class="user-cookies-consent__header">
            <h2>{{'components.user-cookies.cookiesSettings' | translate}}</h2>
        </div>
        <div class="user-cookies-consent__content">
            <div class="user-cookies-consent__message">
                <h3>{{'components.user-cookies.title' | translate}}</h3>
                <p>{{'components.user-cookies.description' | translate}}</p>
            </div>
            <div class="user-cookies-consent__toggles">
                <mat-slide-toggle 
                    [hideIcon]="true" [(ngModel)]="functional" color="primary">{{'components.user-cookies.functional' | translate}}</mat-slide-toggle>
                <mat-slide-toggle
                    [hideIcon]="true" [(ngModel)]="analytics" color="primary">{{'components.user-cookies.analytics' | translate}}</mat-slide-toggle>
                <mat-slide-toggle
                    [hideIcon]="true" [(ngModel)]="advertisement" color="primary">{{'components.user-cookies.marketing' | translate}}</mat-slide-toggle>
            </div>
        </div>
        <div class="user-cookies-consent__footer">
            <button (click)="acceptAll()" class="mt-2" color="primary" mat-flat-button>{{'components.user-cookies.acceptAll' | translate}}</button>
            <button (click)="close()" class="mt-2" color="primary" mat-flat-button>{{'components.user-cookies.accept' | translate}}</button>
            <button (click)="close()" class="mt-2" color="primary" mat-flat-button>{{'components.user-cookies.refuse' | translate}}</button>
        </div>
    </div>
</div>
